import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import InputMask from "react-input-mask";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import EkipaRadioGroup from "./CalcComponents/EkipaRadioGroup";
import CheckBox from "./CalcComponents/CheckBox";
import { changeTeam, setSetvices, setCzasPracy, fetchLoaderRun, setMessage } from "../actions";
import Server from "./Server";
import CzasPracyRadioGroup from "./CalcComponents/CzasPracyRadioGroup";
import { connect } from "react-redux";
//import { stat } from "fs";
import Result from "./Result";
import M from "materialize-css";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "./Divider";

const styles = (theme) => ({
	labelOverride: {
		label: {
			background: "#ffffff",
			padding: "0 10px"
		}
	},
	progress: {
		margin: theme.spacing.unit * 2
	},
	root: {
		width: "90%",
		textAlign: "left",
		margin: "0 auto"
	},
	label: {
		textAlign: "left"
	},
	formLabel: {
		background: "#ffffff",
		padding: "0 10px"
	},
	button: {
		marginTop: "5px",
		marginRight: "5px",
		fontSize: "14px !important"
	},

	actionsContainer: {
		marginBottom: theme.spacing.unit * 2
	},
	resetContainer: {
		padding: theme.spacing.unit * 3
	},
	container: {
		display: "flex",
		flexWrap: "wrap"
	},

	dense: {
		width: "100%",
		marginTop: 16,
		marginLeft: 0
	},
	menu: {
		width: 200
	}
});

function getSteps(langBase) {
	return [ langBase.il9n.step1, langBase.il9n.step2, langBase.il9n.step3 ];
}

class VerticalLinearStepper extends React.Component {
	state = {
		activeStep: 0,
		isResult: null,
		message: null,
		flag: null
	};

	controller = new AbortController();
	timeout = null;

	clearMessage = () => {
		this.timeout && clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.props.setMessage(null);
		}, 5000);
	};

	setTeam = () => {
		this.setState((state) => ({
			activeStep: state.activeStep + 1
		}));
		this.props.setSetvices(null, true);
	};

	handleNext = () => {
		this.setState((state) => ({
			activeStep: state.activeStep + 1
		}));
	};

	handleBack = () => {
		this.setState((state) => ({
			activeStep: state.activeStep - 1
		}));
		this.props.setCzasPracy(null);
	};

	handleReset = () => {
		this.props.changeTeam(null);
		this.setState({
			activeStep: 0
		});
		this.props.setSetvices(null);
	};

	sendAccept = () => {
		this.controller = new AbortController();
		this.props.fetchLoaderRun(true);
		const name = document.querySelector("#name").value;
		const phone = document.querySelector("#phone").value;
		const email = document.querySelector("#email").value;
		const data = {
			name,
			email,
			phone,
			services: this.props.services,
			czasPracy: this.props.czasPracy
		};
		fetch(Server.accept, {
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(data),
			method: "POST",
			mode: "cors",
			redirect: "follow",
			credentials: "include",
			signal: this.controller.signal
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.responseCode) {
					this.props.fetchLoaderRun(false);
					this.setState(
						{
							message: data.responseDesc,
							flag: "error"
						},
						() => {
							this.showStatusModal();
						}
					);
				} else {
					this.props.fetchLoaderRun(false);
					this.props.setSetvices(null);
					this.setState(
						{
							message: data.responseDesc,
							flag: "success"
						},
						() => {
							this.showStatusModal();
						}
					);
				}
			})
			.catch((err) => {
				this.setState(
					{
						message: data.responseDesc,
						flag: "error"
					},
					() => {
						this.showStatusModal();
					}
				);
				console.log(err.message);
			});
	};

	showStatusModal = (message, flag) => {
		const elem = document.querySelector("#modal2");
		const instance = M.Modal.getInstance(elem);
		instance && instance.open();
	};

	sendToCalculate = () => {
		this.props.fetchLoaderRun(true);
		const ekipa = this.props.ekipa;
		const data = {
			ekipa,
			services: this.props.services,
			czasPracy: this.props.czasPracy
		};

		fetch(Server.sum, {
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(data),
			method: "POST",
			mode: "cors",
			redirect: "follow",
			credentials: "include",
			signal: this.controller.signal
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.responseCode) {
					this.props.fetchLoaderRun(false);
					this.props.setMessage("error", this.props.langBase[data.responseDesc]);
					this.clearMessage();
					if (data.responseDesc === "need_time") {
						this.setState({
							activeStep: 2
						});
						return;
					}
					if (data.responseDesc === "need_zdje") {
						this.setState({
							activeStep: 1
						});
						return;
					}
				} else {
					this.props.fetchLoaderRun(false);
					this.props.setSetvices(null);
				}

				if (!data.responseCode) {
					//final result recieved
					const { langBase, czasPracy, services } = this.props;
					const filteredServices = services.filter((el) => el.checked);
					const servicesNames = filteredServices.map((service) => {
						let info = null;
						if (service.tasks) {
							if (service.value <= 1) {
								info = langBase.il9n[service.tasks[service.value].text];
							} else {
								info = service.value + " " + langBase.il9n.unit;
							}
						} else {
							//info = service.info;

							info = service.name !== "DRON" ? langBase.il9n["another_day"] : "";
						}
						return {
							name: langBase.il9n[service.name],
							info
						};
					});

					this.setState({
						isResult: {
							ekipa: langBase.il9n[`$${ekipa.toLowerCase()}`],
							ekipa_desc: `$desc_${ekipa.toLowerCase()}`,
							czas: langBase.il9n[`$czas_${czasPracy - 1}`],
							services: servicesNames,
							total: data.total
						}
					});
				}
			})
			.catch((err) => {
				this.props.setMessage("error", this.props.langBase[err.responseDesc]);
				this.clearMessage();
				console.log(err.message);
			});
	};

	showModal = () => {
		var elems = document.querySelectorAll(".modal");
		var instances = M.Modal.init(elems);
		instances[1] && instances[1].open();
	};

	componentWillUnmount() {
		this.controller.abort();
		this.props.setCzasPracy(null);
		clearTimeout(this.timeout);
	}

	render() {
		const { classes, langBase } = this.props;
		const steps = getSteps(this.props.langBase);
		const { activeStep } = this.state;
		const { services } = this.props;

		if (this.state.isResult) {
			return (
				<React.Fragment>
					<Result data={this.state.isResult} />
					<div className="total">{this.state.isResult.total} zł.</div>
					<div className="send">
						<Button onClick={this.showModal} className={classes.button}>
							{this.props.langBase.accept}
						</Button>
					</div>
					<div id="modal2" className="modal">
						<div
							className="modal-content"
							style={{
								color: this.state.flag === "error" ? "#d2093a" : "#1d99b4"
							}}>
							<h3>{langBase[this.state.flag]}</h3>
							<p>{langBase[this.state.message]}</p>
						</div>
						<div className="modal-footer">
							{this.state.flag === "success" && (
								<Button
									color="primary"
									onClick={() => this.props.close("close")}
									className={classes.button}>
									OK
								</Button>
							)}
							{this.state.flag !== "success" && (
								<Button color="primary" className={classes.button + " modal-close"}>
									OK
								</Button>
							)}
						</div>
					</div>
					<div id="modal1" className="modal">
						<div className="modal-content">
							<Divider width={100} />
							{/* <h2>{langBase.acceptTitle}</h2> */}
							<p className="disclaimer">{langBase.disclaimer}</p>
							<p className="disclaimer">{langBase.disclaimer2}</p>
							<div className="form-2">
								<form
									onSubmit={this.handleSubmit}
									id="comment_form_2"
									method="post"
									style={{ position: "relative" }}>
									<TextField
										id="name"
										label={langBase.yourName || "Imię"}
										name="name"
										className={classNames(classes.textField, classes.dense)}
										classes={{
											root: classes.labelOverride
										}}
										margin="dense"
										variant="outlined"
										autoComplete="off"
									/>
									<br />
									<InputMask
										mask="999-999-999"
										//value={this.state.postCode}
										onChange={this.inputHandler}
										className={"inputPostal " + classNames(classes.textField, classes.dense)}
										value={this.state.postCode}>
										{() => (
											<TextField
												id="phone"
												label={langBase.yourPhone || "Telefon"}
												name="phone"
												className={classNames(classes.textField, classes.dense)}
												classes={{
													root: classes.labelOverride
												}}
												margin="dense"
												variant="outlined"
												autoComplete="off"
											/>
										)}
									</InputMask>

									<br />
									<TextField
										id="email"
										label={langBase.yourEmail || "Email"}
										name="email"
										className={classNames(classes.textField, classes.dense)}
										classes={{
											root: classes.labelOverride
										}}
										margin="dense"
										variant="outlined"
										autoComplete="off"
									/>
									<br />
									{/* <SendButton type="submit" text={langBase.addOpinion} /> */}
									<br />
									<br />
								</form>
							</div>
						</div>
						<div className="modal-footer" style={{ padding: "0" }}>
							{(this.props.fetching && (
								<div>
									<CircularProgress className={classes.progress} color="primary" />
								</div>
							)) || (
								<React.Fragment>
									<Button color="primary" onClick={this.sendAccept} className={classes.button}>
										{this.props.langBase.accept}
									</Button>
									<Button onClick={() => this.props.close("close")} className={classes.button}>
										CLOSE
									</Button>
								</React.Fragment>
							)}
						</div>
					</div>
				</React.Fragment>
			);
		}

		return (
			<div className={classes.root}>
				<Stepper activeStep={activeStep} orientation="vertical">
					<Step>
						<StepLabel>{this.props.langBase.il9n.step1}</StepLabel>
						<StepContent>
							<EkipaRadioGroup />

							<div className={classes.actionsContainer}>
								<div>
									<Button
										disabled={activeStep === 0}
										onClick={this.handleBack}
										className={classes.button}>
										{this.props.langBase.il9n.prev}
									</Button>
									<Button
										disabled={this.props.stepBtn}
										variant="contained"
										color="primary"
										onClick={this.setTeam}
										className={classes.button}>
										{this.props.langBase.il9n.next}
									</Button>
								</div>
							</div>
						</StepContent>
					</Step>
					{/* Step 2 */}
					<Step>
						<StepLabel>{this.props.langBase.il9n.step2}</StepLabel>
						<StepContent>
							{services && <CheckBox />}
							<div className={classes.actionsContainer}>
								<div>
									<Button
										disabled={activeStep === 0}
										onClick={this.handleBack}
										className={classes.button}>
										{this.props.langBase.il9n.prev}
									</Button>
									<Button
										disabled={false}
										variant="contained"
										color="primary"
										onClick={this.setTeam}
										className={classes.button}>
										{this.props.langBase.il9n.next}
									</Button>
								</div>
							</div>
						</StepContent>
					</Step>
					{/* Step 2 */}
					<Step>
						<StepLabel>{this.props.langBase.il9n.step3}</StepLabel>
						<StepContent>
							<CzasPracyRadioGroup />
							<div className={classes.actionsContainer}>
								<div>
									<Button
										disabled={activeStep === 0}
										onClick={this.handleBack}
										className={classes.button}>
										{this.props.langBase.il9n.prev}
									</Button>
									<Button
										disabled={!this.props.ekipa ? true : false}
										variant="contained"
										color="primary"
										onClick={this.setTeam}
										className={classes.button}>
										{this.props.langBase.il9n.finish}
									</Button>
								</div>
							</div>
						</StepContent>
					</Step>
				</Stepper>
				{activeStep === steps.length && (
					<Paper square elevation={0} className={classes.resetContainer}>
						<Typography>{this.props.langBase.steps_end}</Typography>
						<Button onClick={this.handleReset} className={classes.button}>
							Reset
						</Button>
						<Button
							disabled={false}
							variant="contained"
							color="primary"
							onClick={this.sendToCalculate}
							className={classes.button}>
							{this.props.langBase.send_calc}
						</Button>
					</Paper>
				)}
			</div>
		);
	}
}

VerticalLinearStepper.propTypes = {
	classes: PropTypes.object
};

const mapStateToProps = (state) => ({
	langBase: state.langBase,
	services: state.services,
	czasPracy: state.czasPracy,
	ekipa: state.ekipa,
	stepBtn: state.stepBtn,
	city: state.city,
	fetching: state.fetching
});

const mapDispatchToProps = {
	changeTeam,
	setSetvices,
	setCzasPracy,
	fetchLoaderRun,
	setMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VerticalLinearStepper));
